import React from "react";
import { FC } from "react";
import { Typography } from "@material-ui/core";
import { TypographyProps } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";
import FontIcon from "../FontIcon";
import { FontIconProps } from "../FontIcon/FontIcon";
import { FontIconNames } from "../FontIcon/FontIcon";
import clsx from "clsx";

interface ErrorProps {
  icon?: FontIconNames;
  iconProps?: Partial<FontIconProps>;
  text?: string;
  className?: string;
  typographyProps?: TypographyProps;
  children?: any;
  fullHeight?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#adadad",
  },
  fullHeight: {
    height: "calc(100vh - 250px)",
  },
  icon: {
    marginBottom: theme.spacing(4),
  },
  typography: {
    fontWeight: 500,
    marginBottom: theme.spacing(4),
  },
}));

const Error: FC<ErrorProps> = ({
  icon,
  iconProps,
  text,
  children,
  typographyProps,
  className,
  fullHeight = true,
  ...rootProps
}) => {
  const classes = useStyles();

  return (
    <div
      {...rootProps}
      className={clsx(
        classes.root,
        fullHeight && classes.fullHeight,
        rootProps && className,
      )}
    >
      {icon && (
        <FontIcon
          name={icon}
          {...{
            fontSize: "large",
            ...iconProps,
            className: clsx(classes.icon, iconProps && iconProps.className),
          }}
        />
      )}
      <Typography
        {...{
          align: "center",
          variant: "h3",
          ...typographyProps,
        }}
        className={clsx(
          classes.typography,
          typographyProps && typographyProps.className,
        )}
      >
        {children || text || "Nothing found"}
      </Typography>
    </div>
  );
};

export default React.memo(Error);
